(ns nl.mediquest.questionnaire-frontend.subs
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::active-panel
 (fn [db _]
   (:active-panel db)))

(re-frame/reg-sub
 ::report-data
 (fn [{:questionnaire/keys [report-data]}]
   report-data))

(re-frame/reg-sub
 :questionnaire/questionnaire-deployment-id
 (fn [db]
   (:questionnaire/questionnaire-deployment-id db)))

(re-frame/reg-sub
 :questionnaire/questionnaire-id
 (fn [db]
   (:questionnaire/questionnaire-id db)))

(re-frame/reg-sub
 :questionnaire/backend.error
 (fn [db]
   (:questionnaire/backend.error db)))

(re-frame/reg-sub
 :questionnaire/contact-bij-vragen-hiccup
 (fn [db]
   (or (:contact-bij-vragen-hiccup db) ; specific takes precedence
       (-> db
           :questionnaire/config
           :questionnaire/contact-bij-vragen-hiccup))))

(re-frame/reg-sub
 :questionnaire/deelname-anoniem-hiccup
 (fn [db]
   (-> db
       :questionnaire/config
       :questionnaire/deelname-anoniem-hiccup)))

(re-frame/reg-sub
 :questionnaire/survey-model
 (fn [db]
   (:questionnaire/survey-model db)))

(re-frame/reg-sub
 :questionnaire/config
 (fn [db]
   (:questionnaire/config db)))

(re-frame/reg-sub
 :questionnaire/fetching?
 (fn [db]
   (:questionnaire/fetching? db)))

(re-frame/reg-sub
 :questionnaire/survey
 (fn [db]
   (:questionnaire/survey db)))

(re-frame/reg-sub
 :questionnaire/show-report?
 :<- [:questionnaire/survey]
 (fn [{:keys [showReport] :as _survey}]
   showReport))

;; `:questionnaire/survey` is only present in db if the user has
;; filled out the questionnaire before navigating to the report.
(re-frame/reg-sub
 :report/show-link-to-mijn-positieve-gezondheid-reflectie?
 :<- [:questionnaire/survey]
 (fn [survey]
   (some? survey)))

(re-frame/reg-sub
 :questionnaire/deploy-status
 (fn [db]
   (:questionnaire/deploy-status db)))

(re-frame/reg-sub
 :questionnaire/header-logo-src
 (fn [db]
   (:questionnaire/header-logo-src db)))

(re-frame/reg-sub
 :questionnaire/unsubscribe?
 (fn [db]
   (:questionnaire/unsubscribe? db)))

(re-frame/reg-sub
 :questionnaire/base-url
 (fn [{:questionnaire/keys [base-url] :as _db}]
   base-url))

(re-frame/reg-sub
 :mijn-positieve-gezondheid/url-questionnaire-reflectie
 :<- [:questionnaire/base-url]
 :<- [:questionnaire/questionnaire-deployment-id]
 (fn [[base-url questionnaire-deployment-id]]
   (let [questionnaire-id "mijn-positieve-gezondheid-reflectie"]
     (str base-url
          "/"
          questionnaire-id
          "/"
          questionnaire-deployment-id))))

(re-frame/reg-sub
 :report/show-email-button?
 (fn [db]
   (:report/show-email-button? db)
   true))

(re-frame/reg-sub
 ::language
 (fn [{:i18n/keys [languages] :as _db} [_ locale]]
   (get languages locale)))

(re-frame/reg-sub
 ::locales
 (fn [{:keys [i18n/locales questionnaire/available-locales]
       :as _db}]
   (or (seq available-locales) (seq locales))))

(re-frame/reg-sub
 ::selected-locale
 (fn [{:i18n/keys [selected-locale locales] :as _db}]
   (or selected-locale (first locales))))

(re-frame/reg-sub
 ::locale-dropdown-open?
 (fn [{:i18n/keys [locale-dropdown-open?] :as _db}]
   locale-dropdown-open?))

(re-frame/reg-sub
 :questionnaire/show-language-dropdown?
 (fn [{:questionnaire/keys [show-language-dropdown?] :as _db}]
   show-language-dropdown?))
